import { Image, Stack } from 'react-bootstrap'
import { Link, matchPath, useLocation } from 'react-router-dom'
//
import './sidebar.css'
import Logo from '../../assets/logo/logo.jpeg'
import { CLASSES, COLORS } from '../../assets/styles/styles'
import { SIDEBAR_ITEMS } from './sidebar_data'
import { useSelector } from 'react-redux'
import Logout from './Logout'
import HelpIcon from '../../assets/icons/sidebar/help-circle.svg'
import AlertIcon from '../../assets/icons/sidebar/alert-triangle.svg'

export default function Sidebar({ style, setShowSidebar = () => {} }) {
  const location = useLocation()
  const { user_role } = useSelector((state) => state.auth)

  const handleClick = (route) => {
    // if (route !== location.pathname) {
    //   navigate(route)
    // }
    setShowSidebar()
  }

  const itemStyle = (isActive) => ({
    backgroundColor: isActive ? '#2c99e3' : '',
    // borderLeft: isActive ? '4px solid white' : '',
    color: 'white',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
  })

  const renderItem = (item, i) => {
    const isAccess =
      item?.permission?.length === 0 || item?.permission?.includes(user_role)
    if (isAccess) {
      const isActive =
        item.route == location.pathname ||
        item?.relativeMatchPaths?.find((_item) =>
          matchPath(_item, location.pathname),
        )

      return (
        <Link
          key={i}
          onClick={() => handleClick(item.route)}
          to={item.route || location.pathname}
          style={itemStyle(isActive)}
          className={`${CLASSES.items_center} p-2 item ${
            isActive ? 'text-white' : 'text-black'
          } px-4`}
        >
          <Image
            src={isActive ? item.icon.white : item.icon.black}
            className='me-2'
          />
          <span>{item.name}</span>
        </Link>
      )
    }
  }

  return (
    <div style={{ ...style }} className='sidebar black-shadow-10'>
      <div className='d-flex flex-column h-100'>
        <div className='text-center text-white mt-2 mb-5'>
          <Image src={Logo} className='p-4' style={{ width: 200 }} />
        </div>

        <Stack gap={2}>
          {SIDEBAR_ITEMS.map(renderItem)}

          <div className='mt-5'>
            {[
              { name: 'Help', icon: HelpIcon },
              { name: 'Support', icon: AlertIcon },
            ].map((item, i) => (
              <div key={i} className='p-2 px-4 item d-flex align-items-center'>
                <Image src={item.icon} className='me-2 svg-icon' />
                <span>{item.name}</span>
              </div>
            ))}
            <Logout />
          </div>
        </Stack>
      </div>
    </div>
  )
}
